export const DataPump = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="26" height="26" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="19" y="8" width="4" height="5" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="14" y="19" width="4" height="5" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M14 7V14" stroke="currentColor" stroke-width="2"/>
<path d="M9 7V14" stroke="currentColor" stroke-width="2"/>
<path d="M9 18V25" stroke="currentColor" stroke-width="2"/>
<path d="M23 18V25" stroke="currentColor" stroke-width="2"/>
</svg>`;
